export function htmlToText(html?: string) {
  try {
    return html?.replace(/<[^>]+>/g, '').replace(/[\r\n]/g, '') || ''
  } catch (error) {
    return ''
  }
}
